import { StyleSheet } from 'react-native';
import Typography from '../../../shared/constants/Typography';

export const createNovaAIChatWindowStyles = (theme: any) =>
  StyleSheet.create({
    modalView: {
      flex: 1,
      backgroundColor: theme.bGColor,
      flexDirection: 'column',
    },
    headerView: {
      flexDirection: 'row',
      justifyContent: Typography.contentAlign.spaceBetween,
      width: Typography.fullWidth,
      padding: Typography.padding.padding24,
    },
    leftHeaderView: {
       flexDirection: 'row',
       gap: Typography.gap.gap10,
       alignItems: Typography.textAlign.centerAlign
    },
    headerRightActions: {
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap4,
    },
    header: {
      width: Typography.fullWidth,
      alignItems: Typography.contentAlign.flexEnd,
    },
    listWrapper: {
      flex: 1, 
      marginHorizontal: Typography.margin.margin16,
      paddingVertical: Typography.padding.padding24
    },
    message: {
      maxWidth: Typography.width.width448,
      padding: Typography.padding.padding12,
      margin: Typography.margin.margin12,
      borderRadius: Typography.radius.radius12,
      marginBottom: Typography.margin.margin10,
    },
    botMessageView: {
      borderBottomRightRadius: 0,
    },
    userMessage: {
      backgroundColor: theme.userMessageBGColor,
      alignSelf: Typography.contentAlign.flexEnd,
      color: theme.userMessageColor,
      borderColor: theme.userMessageBorder,
    },
    botMessage: {
      backgroundColor: theme.botMessageBGColor,
      alignSelf: Typography.contentAlign.flexStart,
      borderWidth: Typography.borderWidth.borderWidth1,
      color: theme.botMessageColor,
      borderColor: theme.botMessageBorder,
    },
    messageText: {
      color: theme.userMessageText,
      fontSize: Typography.fontSize.fontSize14,
      fontFamily: Typography.fontFamily.inter,
      fontWeight: Typography.fontWeight.regular
    },
    botMessageText: {
      color: theme.botMessageText,
      fontSize: Typography.fontSize.fontSize14,
      fontFamily: Typography.fontFamily.inter,
      fontWeight: Typography.fontWeight.regular
    },
    noResultText: {
      color: theme.novaAIContextSubText,
      fontSize: Typography.fontSize.fontSize13,
      fontFamily: Typography.fontFamily.inter,
      fontWeight: Typography.fontWeight.regular,
      fontStyle: 'italic' as const,
      marginTop: Typography.margin.margin4,
    },
    list: {
      marginTop: Typography.margin.margin4,
      gap: Typography.gap.gap24
    },
    inputContainer: {
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      paddingHorizontal: Typography.padding.padding16,
      paddingVertical: Typography.padding.padding12,
      borderTopWidth: Typography.borderWidth.borderWidth1,
      borderTopColor: theme.searchTextInputTopBorderColor,
      gap: Typography.gap.gap8,
      marginTop: Typography.margin.margin16,
      marginBottom: Typography.margin.margin8,
    },
    input: {
      flex: 1,
      height: Typography.height.height48,
      backgroundColor: 'transparent',
      borderRadius: Typography.radius.radius4,
      fontSize: Typography.fontSize.fontSize16,
      color: theme.inputTextColor,
      borderWidth: Typography.borderWidth.borderWidth1,
      borderColor: theme.inputTextBorderColor,
      textAlignVertical: Typography.textAlign.centerAlign,
      paddingHorizontal: Typography.padding.padding16,
      paddingVertical: 0,
      includeFontPadding: false,
    },
    sendButton: {
      width: Typography.width.width44,
      height: Typography.height.height44,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
      alignSelf: Typography.textAlign.centerAlign,
    },
    footerText: {
      textAlign: Typography.textAlign.centerAlign,
      fontSize: Typography.fontSize.fontSize12,
      color: theme.footerTextColor,
      paddingBottom: Typography.padding.padding16,
      fontFamily: Typography.fontFamily.inter,
    },
    textContainer: {
      flex: 1,
      height: Typography.height.height48,
      justifyContent: Typography.textAlign.centerAlign,
      marginBottom: 0,
    },
    micBtn: {
      width: Typography.width.width44,
      height: Typography.height.height44,
      borderRadius: Typography.radius.radius22,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
      alignSelf: Typography.textAlign.centerAlign,
    },
    micBtnRecording: {
      //backgroundColor: '#ffdddd',
    },
    cardTextWrapper: {
      flexDirection: 'column',
      gap: Typography.gap.gap4,
    },
    assistanceScroll: {
      flex: 1,
    },
    iconWrapper: {
      flexGrow: 1, // contentContainerStyle: centres when space allows, scrolls when it doesn't
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
      padding: Typography.padding.padding24,
    },
    iconBackground: {
      alignSelf: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
    },
    mainContainer: {
      flexDirection: 'row',
      gap: Typography.gap.gap16
    },
    chatRow: {
      width: Typography.fullWidth,
      flexDirection: Typography.flexDirection.row,
      alignItems: Typography.contentAlign.flexStart,
      paddingHorizontal: Typography.padding.padding12,
    },
    chatRowUser: {
      justifyContent: Typography.contentAlign.flexEnd,
    },
    chatRowBot: {
      justifyContent: Typography.contentAlign.flexStart,
    },
    inlineBotIcon: {
      width: Typography.width.width44,
      height: Typography.height.height44,
      borderRadius: Typography.radius.radius10,
      backgroundColor: theme.botIconBGColor,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
      marginRight: Typography.margin.margin8,
      marginTop: Typography.margin.margin2,
    },
    inlineBotIconImage: {
      width: Typography.width.width30,
      height: Typography.height.height30,
    },
    headerText: {
      fontSize: Typography.fontSize.fontSize22,
      fontWeight: Typography.fontWeight.semiBold,
      color: theme.novaAIContextText,
      fontFamily: Typography.fontFamily.inter,
    },
    minimizeChevron: {
      fontSize: Typography.fontSize.fontSize18,
      color: theme.novaAIContextText,
      fontFamily: Typography.fontFamily.inter,
      lineHeight: Typography.lineHeight.lineHeight24,
      width: Typography.width.width24,
      textAlign: Typography.textAlign.centerAlign,
    },
    chatMessage: {
      margin: 0,
    },
    botIcon: {
      width: Typography.width.width60,
      height: Typography.height.height60,
    },
    title: {
      fontSize: Typography.fontSize.fontSize24,
      fontWeight: Typography.fontWeight.semiBold,
      color: theme.novaAIContextText,
      textAlign: Typography.textAlign.centerAlign,
      fontFamily: Typography.fontFamily.inter,
    },
    titleMainContainer: {
      flexDirection: 'column',
      gap: Typography.gap.gap24,
    },
    titlesContainer: {
      flexDirection: 'column',
      gap: Typography.gap.gap8,
      paddingHorizontal: Typography.padding.padding16
    },
    listContainer: {
      flexDirection: 'column',
      gap: Typography.gap.gap12,
      justifyContent: Typography.textAlign.centerAlign,
    },
    subtitle: {
      fontSize: Typography.fontSize.fontSize16,
      color: theme.novaAIContextSubText,
      textAlign: Typography.textAlign.centerAlign,
      fontFamily: Typography.fontFamily.inter,
      flexWrap: 'wrap',
      fontWeight: Typography.fontWeight.regular,
    },
    card: {
      flexDirection: 'row',
      paddingVertical: Typography.padding.padding14,
      paddingHorizontal: Typography.padding.padding16,
      gap: Typography.gap.gap12,
      borderColor: theme.cardBorderColor,
      borderWidth: Typography.borderWidth.borderWidth1,
      borderRadius: Typography.radius.radius4,
    },
    cardTitle: {
      fontWeight: Typography.fontWeight.semiBold,
      fontSize: Typography.fontSize.fontSize14,
      color: theme.cardTextColor,
      fontFamily: Typography.fontFamily.inter,
    },
    cardExample: {
      fontSize: Typography.fontSize.fontSize12,
      fontWeight: Typography.fontWeight.regular,
      color: theme.cardExampleTextColor,
      fontFamily: Typography.fontFamily.inter,
    },
    placeHolderStyles: {
      fontSize: Typography.fontSize.fontSize12,
      fontWeight: Typography.fontWeight.regular,
      fontFamily: Typography.fontFamily.inter,
      opacity: 0.6,
    },
    waveformContainer: {
      flexDirection: Typography.flexDirection.row,
      alignItems: Typography.textAlign.centerAlign,
      height: Typography.height.height20,
      width: Typography.width.width300,
      gap: Typography.gap.gap2,
      paddingHorizontal: Typography.padding.padding4,
    },
    waveformBar: {
      width: Typography.width.width2,
      height: Typography.height.height28,
      borderRadius: Typography.radius.radius2,
      backgroundColor: theme.waveformBarColor,
    },
    lineSeparator: {
      borderTopWidth: Typography.borderWidth.borderWidth1,
      borderTopColor: theme.searchTextInputTopBorderColor,
    },

    // ── Per-message timestamp shown below the bubble content ──────────────
    messageTimestamp: {
      fontSize: Typography.fontSize.fontSize12,
      color: theme.novaAIContextSubText,
      fontFamily: Typography.fontFamily.inter,
      marginTop: Typography.margin.margin4,
    },
    messageTimestampUser: {
      textAlign: Typography.textAlign.rightAlign,
      color: theme.waveformBarColor,
    },

    // ── Wider wrapper overrides message maxWidth for structured bot replies ─
    structuredMessageWrapper: {
      flex: 1,
      maxWidth: Typography.fullWidth,
    },

    // ── BotStructuredMessage table ─────────────────────────────────────────
    tableWrapper: {
      width: Typography.fullWidth,
    },
    tableHeaderText: {
      fontSize: Typography.fontSize.fontSize13,
      color: theme.botMessageText,
      fontFamily: Typography.fontFamily.inter,
      marginBottom: Typography.margin.margin8,
      lineHeight: Typography.lineHeight.lineHeight20,
    },
    tableContainer: {
      borderRadius: Typography.radius.radius4,
      overflow: 'hidden',
      borderWidth: Typography.borderWidth.borderWidth1,
      borderColor: theme.listViewBorder,
    },
    // Column header row inside the table (derived from first row key parts)
    tableColHeaderRow: {
      flexDirection: Typography.flexDirection.row,
      borderBottomWidth: Typography.borderWidth.borderWidth1,
      borderBottomColor: theme.listViewBorder,
      minHeight: Typography.width.width40,
      alignItems: Typography.textAlign.centerAlign,
      backgroundColor: theme.listViewHeaderBG,
    },
    tableColHeaderCellText: {
      fontSize: Typography.fontSize.fontSize12,
      fontWeight: Typography.fontWeight.semiBold,
      color: theme.listViewHeaderText,
      fontFamily: Typography.fontFamily.inter,
      lineHeight: Typography.lineHeight.lineHeight16,
    },
    // maxHeight = ROW_HEIGHT(52) × VISIBLE_ROWS(4)
    tableScrollArea: {
      maxHeight: Typography.width.width210,
    },
    tableRow: {
      flexDirection: Typography.flexDirection.row,
      borderBottomWidth: Typography.borderWidth.borderWidth1,
      borderBottomColor: theme.listViewBorder,
      minHeight: Typography.width.width50,
      alignItems: Typography.textAlign.centerAlign,
    },
    tableIndexCell: {
      width: Typography.width.width28,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
      paddingVertical: Typography.padding.padding8,
      borderRightWidth: Typography.borderWidth.borderWidth1,
      borderRightColor: theme.listViewBorder,
      alignSelf: 'stretch',
    },
    tableIndexText: {
      fontSize: Typography.fontSize.fontSize10,
      fontWeight: Typography.fontWeight.semiBold,
      color: theme.listViewHeaderText,
      fontFamily: Typography.fontFamily.inter,
    },
    tableCell: {
      flex: 1,
      paddingHorizontal: Typography.padding.padding8,
      paddingVertical: Typography.padding.padding6,
      borderRightWidth: Typography.borderWidth.borderWidth1,
      borderRightColor: theme.listViewBorder,
      alignSelf: 'stretch',
      justifyContent: Typography.textAlign.centerAlign,
    },
    tableLastCell: {
      borderRightWidth: 0,
    },
    tableCellText: {
      fontSize: Typography.fontSize.fontSize12,
      color: theme.botMessageText,
      fontFamily: Typography.fontFamily.inter,
      lineHeight: Typography.lineHeight.lineHeight18,
    },
    tableScrollHint: {
      paddingVertical: Typography.padding.padding4,
      paddingHorizontal: Typography.padding.padding8,
      backgroundColor: theme.listViewHeaderBG,
      alignItems: Typography.textAlign.centerAlign,
    },
    tableScrollHintText: {
      fontSize: Typography.fontSize.fontSize10,
      color: theme.listViewHeaderText,
      fontFamily: Typography.fontFamily.inter,
    },

    // ── Item card styles (structuredData key-value card rendering) ──────────
    itemCard: {
      borderRadius: Typography.radius.radius8,
      overflow: 'hidden',
      borderWidth: Typography.borderWidth.borderWidth1,
      borderColor: theme.listViewBorder,
      marginBottom: Typography.margin.margin8,
    },
    itemCardSpacing: {
      marginTop: Typography.margin.margin4,
    },
    itemCardHeader: {
      backgroundColor: theme.listViewHeaderBG,
      paddingVertical: Typography.padding.padding6,
      paddingHorizontal: Typography.padding.padding8,
      borderBottomWidth: Typography.borderWidth.borderWidth1,
      borderBottomColor: theme.listViewBorder,
    },
    itemCardHeaderText: {
      fontSize: Typography.fontSize.fontSize12,
      fontWeight: Typography.fontWeight.semiBold,
      color: theme.listViewHeaderText,
      fontFamily: Typography.fontFamily.inter,
    },
    itemCardRow: {
      flexDirection: Typography.flexDirection.row,
      paddingHorizontal: Typography.padding.padding8,
      paddingVertical: Typography.padding.padding6,
      borderBottomWidth: Typography.borderWidth.borderWidth1,
      borderBottomColor: theme.listViewBorder,
    },
    itemCardKey: {
      flex: 1,
      fontSize: Typography.fontSize.fontSize12,
      fontWeight: Typography.fontWeight.semiBold,
      color: theme.listViewHeaderText,
      fontFamily: Typography.fontFamily.inter,
    },
    itemCardValue: {
      flex: 2,
      fontSize: Typography.fontSize.fontSize12,
      color: theme.botMessageText,
      fontFamily: Typography.fontFamily.inter,
      lineHeight: Typography.lineHeight.lineHeight18,
    },

    // ── Table row alternating background ───────────────────────────────────
    tableRowEven: {
      backgroundColor: theme.listViewHeaderBG,
    },
    tableRowOdd: {
      backgroundColor: theme.listViewBG,
    },

    // ── Row separator (used by ItemSeparatorComponent if FlatList is used) ─
    separator: {
      height: Typography.borderWidth.borderWidth1,
      backgroundColor: theme.listViewBorder,
    },

    // ── Expanded two-column body layout ───────────────────────────────────
    expandedBody: {
      flex: 1,
      flexDirection: 'row' as const,
    },
    normalBody: {
      flex: 1,
    },
    /** Chat takes up all available space in normal mode */
    chatColumnFull: {
      flex: 1,
    },
    /** Chat column shrinks to share space with the right panel */
    chatColumn: {
      flex: 1,
      borderRightWidth: Typography.borderWidth.borderWidth1,
      borderRightColor: theme.searchTextInputTopBorderColor,
    },

    // ── Suggested questions right panel ───────────────────────────────────
    suggestedPanel: {
      width: Typography.width.width307,
      padding: 20,
      backgroundColor: theme.bGColor,
    },
    suggestedPanelTitle: {
      fontSize: Typography.fontSize.fontSize16,
      fontWeight: Typography.fontWeight.semiBold,
      color: theme.novaAIContextText,
      fontFamily: Typography.fontFamily.inter,
      marginBottom: Typography.margin.margin12,
    },
    suggestedCard: {
      borderWidth: Typography.borderWidth.borderWidth1,
      borderColor: theme.novaAIBorderColor,
      borderRadius: Typography.radius.radius8,
      paddingVertical: Typography.padding.padding13,
      paddingHorizontal: Typography.padding.padding15,
    },
    suggestedQuestions: {
      flexDirection: 'column' as const,
      gap: Typography.gap.gap12,
    },
    suggestedCardCategoryRow: {
      flexDirection: 'row' as const,
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap6,
      marginBottom: Typography.margin.margin4,
    },
    suggestedCardCategoryText: {
      fontSize: Typography.fontSize.fontSize10,
      fontWeight: Typography.fontWeight.semiBold,
      fontFamily: Typography.fontFamily.inter,
    },
    suggestedCardQuestion: {
      fontSize: Typography.fontSize.fontSize12,
      color: theme.novaAIContextText,
      fontFamily: Typography.fontFamily.inter,
      fontWeight: Typography.fontWeight.medium,
      lineHeight: Typography.lineHeight.lineHeight18,
    },

    // ── Capabilities section inside the suggested panel ───────────────────
    capabilitySection: {
      marginTop: Typography.margin.margin20,
      paddingTop: Typography.padding.padding20,
      borderTopWidth: Typography.borderWidth.borderWidth1,
      borderTopColor: theme.novaAIBorderColor,
    },
    capabilitySectionTitle: {
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.semiBold,
      color: theme.novaAIContextText,
      fontFamily: Typography.fontFamily.inter,
      marginBottom: Typography.margin.margin12,
    },
    capabilityItem: {
      flexDirection: 'row' as const,
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap8,
      marginBottom: Typography.margin.margin10,
    },
    capabilityCheckIcon: {
      width: Typography.width.width18,
      height: Typography.height.height18,
      borderRadius: Typography.radius.radius9,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
    },
    capabilityText: {
      flex: 1,
      fontSize: Typography.fontSize.fontSize12,
      color: theme.novaAIContextText,
      fontFamily: Typography.fontFamily.inter,
      fontWeight: Typography.fontWeight.regular,
    },

    // ── Loading / empty state for suggested panel ─────────────────────────
    suggestedPanelLoading: {
      flex: 1,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
      paddingVertical: Typography.padding.padding24,
    },
    suggestedPanelLoadingText: {
      fontSize: Typography.fontSize.fontSize13,
      color: theme.novaAIContextSubText,
      fontFamily: Typography.fontFamily.inter,
    },
  });
